var map = {
	"./allianz.png": 776,
	"./april.jpg": 777,
	"./asisa.jpg": 778,
	"./europ.jpg": 779,
	"./inter.jpg": 780,
	"./liberty.png": 781,
	"./lusitania.jpg": 782,
	"./mapfre.png": 783,
	"./metlife.png": 784,
	"./prevoir.png": 785,
	"./zurich.svg": 786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;